import { MarginsResponse } from "../../../../api/useGetMargins";
import { Data, getCurrencyValue } from "../../../CallAlertsAuxWindow/auxUtils";

export const buildAccountSummary = (
  marginAccountData: MarginsResponse
): Data[] => {
  const {
    dayTradeBuyingPower,
    netLiquidity,
    cashExcessEquity,
    marginExcess,
    totalConcentrationExcess,
    marginEquity,
    marginConcentrationExcess,
  } = marginAccountData;
  return [
    {
      label: "Intraday Buying Power", // Updated label (FEECM-17670)
      value: getCurrencyValue(dayTradeBuyingPower),
      isNumeric: true,
    },
    {
      label: "Net Liquidating Value",
      value: getCurrencyValue(netLiquidity),
      isNumeric: true,
    },
    {
      label: "Total Excess",
      value: getCurrencyValue(cashExcessEquity),
      isNumeric: true,
    },
    {
      label: "Total Concentration Excess",
      value: getCurrencyValue(totalConcentrationExcess),
      isNumeric: true,
    },
    {
      label: "Margin Equity",
      value: getCurrencyValue(marginEquity),
      isNumeric: true,
    },
    {
      label: "Margin Excess Equity",
      value: getCurrencyValue(marginExcess),
      isNumeric: true,
    },
    {
      label: "Margin Concentration Excess",
      value: getCurrencyValue(marginConcentrationExcess),
      isNumeric: true,
    },
  ];
};
